import React from 'react';
import ReactDOM from 'react-dom';
import {
    RouterProvider,
} from "react-router-dom";

import './index.css';
import { router } from './routes/router';
import { AuthProvider } from './Provider/AuthProvider';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <AuthProvider>
            <RouterProvider router={router} />
        </AuthProvider>
    </React.StrictMode>
);
